"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLabel = void 0;
const tslib_1 = require("tslib");
const theme_1 = require("@monorepo/theme");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
exports.StyledLabel = styled_components_1.default.label `
  font-family: PFDINText;
  font-size: 10.5pt;
  display: flex;
  align-items: baseline;
  opacity: ${({ disabled }) => (disabled ? '0.3' : '1')};
  width: fit-content;

  input[type='radio'] {
    appearance: none;
    margin: 0;
    font: inherit;
    color: ${theme_1.colors.lightGrey};
    width: 20px;
    height: 20px;
    border: 2px solid ${theme_1.colors.lightGrey};
    border-radius: 50%;
    display: grid;
    place-content: center;
    margin-right: 10px;
  }

  input[type='radio']::before {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 10px 10px ${theme_1.colors.lapis};
    background-color: ${theme_1.colors.lapis};
  }

  input[type='radio']:checked {
    border: 2px solid ${theme_1.colors.lapis};
  }

  input[type='radio']:disabled {
    border: 2px solid ${theme_1.colors.black};
  }

  input[type='radio']:disabled::before {
    box-shadow: inset 10px 10px ${theme_1.colors.black};
    background-color: ${theme_1.colors.black};
  }

  input[type='radio']:disabled:not(:checked) {
    background-color: ${theme_1.colors.lightGrey};
  }

  input[type='radio']:checked::before {
    transform: scale(1);
  }
`;
